import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { DirectoryDomain } from "src/app/models/directory/enums/DirectoryDomain.enum";
import { UserType } from "src/app/models/directory/enums/UserType.enum";
import { IDirectoryUser } from "src/app/models/directory/users/DirectoryUser";
import { ServiceAccount, UpdateServiceAccountRequest } from "src/app/models/servicePrivilegeAccounts/UpdateServiceAccountRequest";
import { DirectoryUserService } from "src/app/services/directory/DirectoryUser.service";

@Component({
    selector: 'request-details-service-account-update',
    templateUrl: './request-details-service-account-update.component.html'
})

export class RequestDetailsServiceAccountUpdate implements OnChanges {
    @Input() requestData: UpdateServiceAccountRequest | ServiceAccount[];
    @Output() doneLoading = new EventEmitter<boolean>();

    displayObject: any;
    sharedRequestDetails: any;

    userColumns: string[] = ['userPrincipalName', 'type', 'domain', 'steward', 'serviceId'];
    
    usersUpdateDetails: any[] = [];

    constructor(
        private directoryUserService: DirectoryUserService,
    ) { }

    async ngOnChanges(): Promise<void> {
        const isOldRequestFormat = typeof this.requestData == 'object' && 'serviceAccounts' in this.requestData ? 
            true : false;
        let requestDetails = typeof this.requestData == 'object' && 'serviceAccounts' in this.requestData ? 
            this.requestData.serviceAccounts : this.requestData;
        
        if (requestDetails) {
            
            this.userColumns = [...this.userColumns, 'copyId'];

            // old request format only had the objectId, so we need to load the updated service accounts
            const serviceAccounts = isOldRequestFormat ? await this.loadUpdatedServiceAccounts(requestDetails.map(x => x.userId)) : [];
            const stewards = requestDetails
                .filter(x => x.stewardUserId).map(x => x.stewardUserId);
            const uniqueStewardIds = [... new Set(stewards)]

            let stewardUsers: IDirectoryUser[] = []
            if (uniqueStewardIds && uniqueStewardIds.length > 0) {
                stewardUsers = await this.getStewardUsers(uniqueStewardIds as string[])
            }

            this.usersUpdateDetails = [...requestDetails.map((user: any) => {
                if(isOldRequestFormat){
                    const updatedUserInfo = serviceAccounts.find(x => x.id === user.userId);
                    if (updatedUserInfo) {
                        user.id = updatedUserInfo.id;
                        user.userPrincipalName = updatedUserInfo.userPrincipalName;
                        user.domain = updatedUserInfo.domain;
                        user.type = updatedUserInfo.type;
                        // more to come once serviceId has been added
                    }
                    else {
                        user.userPrincipalName = user.userId;
                        user.domain = DirectoryDomain.Chevron;
                        user.type = UserType.Service;
                    }
                }
                else {
                    user.userPrincipalName = user.emailId;
                    user.type = user.userType || UserType.Service;
                    user.id = user.userId; 
                    user.domain = DirectoryDomain.Chevron;
                }
                
                const stewardUser = stewardUsers.find(steward => steward.id === user.stewardUserId);
                if (stewardUser) {
                    user.steward = stewardUser.displayName;
                }

                // adjust for copyId
                return {
                    userPrincipalName: user.userPrincipalName,
                    type: user.type,
                    copyId: user.id,
                    domain: user.domain,
                    serviceId: user.applicationId,
                    steward: user.steward
                };
            })];
            this.isDoneLoading();
        }
    }

    async loadUpdatedServiceAccounts(ids: string[]) {
        return await this.directoryUserService.GetByIdsAsync({ ids, domain: DirectoryDomain.Chevron });
    }

    async getStewardUsers(stewardIds: string[]) {
        return await this.directoryUserService.GetByIdsAsync({ ids: stewardIds, domain: DirectoryDomain.Chevron });
    }

    isDoneLoading() {
        this.doneLoading.emit(true);
    }
}